import { FieldArrayRenderProps } from 'formik'
import {
  CommonFieldProps,
  DeleteButton,
  HiddenField,
  WrapperProps
} from '../../../../../components'
import { useFieldProps, useFieldValue } from '../../../../../hooks'
import { getContactIndex } from '../utils'

export interface OwnInfoDeleteButtonWrapperProps
  extends Pick<CommonFieldProps, 'name'>,
    WrapperProps {
  arrayHelpers: FieldArrayRenderProps
  isDisabled: boolean
  setDisabled: (disabled: boolean) => void
}

export const OwnInfoDeleteButtonWrapper = ({
  arrayHelpers,
  children,
  isDisabled,
  name,
  setDisabled
}: OwnInfoDeleteButtonWrapperProps) => {
  const fieldValue = useFieldValue(name)

  const hiddenFieldName = `${name}.poisto`

  const { setValue: setHiddenFieldValue, value: hiddenFieldValue } =
    useFieldProps(hiddenFieldName)

  const handleClick = () => {
    if (fieldValue.id === null) {
      // remove new contact right away
      const contactIndex = getContactIndex(name)
      arrayHelpers.remove(contactIndex)
    } else {
      // toggle existing contact to be removed (poisto=1 in Lyyti)
      const val = hiddenFieldValue === 1 ? 0 : 1
      setHiddenFieldValue(val)
      setDisabled(!isDisabled)
    }
  }

  return (
    <>
      {children}
      <HiddenField name={`${name}.poisto`} />
      <DeleteButton
        translationId={isDisabled ? 'common.cancel' : 'common.remove'}
        buttonDisplayType="block"
        onClick={handleClick}
      />
    </>
  )
}
